import { Row } from '../../../../../coaching-observation/experimental.grid';
import { CellContext, RowContext } from '../commitment-narrative.model';

export function filterRowsByCreator(
    createdBy: string[],
    rows: Array<Row<RowContext, CellContext>>,
): Array<Row<RowContext, CellContext>> {
    if (createdBy == null || createdBy.length === 0) {
        return [...rows];
    }

    return rows.filter(
        (row) => row.ctx != null && createdBy.includes(row.ctx.createdBy),
    );
}
